<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import { axiosGetPost } from '@router/axiosGetPost'
import WaitingStatus from '@/src/components/WaitingStatus'
import moment from 'moment'

export default {
  page: {
    title: 'Importation Inlands',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    vueDropzone: vue2Dropzone,
    WaitingStatus,
  },
  props: {
    user: {
      type: [Array, Object],
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      title: 'Importation Inlands',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Inlands',
          href: '/inlands/requests',
        },
        {
          text: 'Import',
          active: true,
        },
      ],
      request_id: this.$route.params.id,
      errors: [],
      reference: null,
      validation: null,
      company: null,
      direction: null,
      type: null,
      country: null,
      currency: null,
      equipment: null,
      provider: null,
      loadingData: false,
      waitingStatusC: false,
      selectedOptions: {
        fileName: null,
        dropzoneOptions: {
          url: process.env.VUE_APP_RUTA_API + 'cargofive/upload_file',
          thumbnailWidth: 150,
          maxFilesize: 10.0,
          dictDefaultMessage:
            "<i class='uil uil-cloud-upload'></i> Upload File",
          maxFiles: 1,
          addRemoveLinks: true,
          headers: {
            Authorization: this.user.token,
          },
        },
      },
      module: 'Inlands',
      message: null,
      messageBool: false,
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'getData',
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.getData()
  },
  methods: {
    getData() {
      // replace `getPost` with your data fetching util / API wrapper
      axiosGetPost('get', `/inlands/importation/${this.request_id}`).then(
        (data) => {
          this.reference = data.reference
          this.validation = `${data.validity} / ${data.expire}`
          this.company = data.company_user.name
          this.direction = data.direction.name
          this.type = data.inland_type.name
          this.country = data.country.name
          this.currency = data.currency.name
          this.equipment = data.gp_container.name
          this.provider = data.provider ? data.provider.name : 'Not Assigned'
        }
      )
    },
    redirectAfterImport() {
      this.$router.replace({ path: `/inlands/requests` })
    },
    saveData() {
      // replace `getPost` with your data fetching util / API wrapper
      this.loadingData = true
      this.messageBool = false
      this.message = null
      axiosGetPost('post', '/inlands/importation/' + this.request_id, {
        selectedOptions: this.selectedOptions,
      }).then((data) => {
        console.log(data)
        if (data.success === true) {
          this.waitingStatusC = true
          this.$toastr.s('Successful. In process.')
        } else {
          this.loadingData = false
          this.messageBool = true
          this.message = data.message + '. Error File.'
          this.$toastr.e(data.message + '. Error File.')
        }
        return data
      })
    },
    removeFile() {
      const dataDic = {
        filename: this.selectedOptions.fileName,
      }
      axiosGetPost('post', '/cargofive/delete_file', dataDic).then(
        (response) => {
          let data = response.data
          if (data.success === true) {
            this.selectedOptions.fileName = null
          } else {
            this.selectedOptions.fileName = null
            this.$toastr.e('Error Delete in Server. Error: ' + data.error)
          }
          return data
        }
      )
    },
    vsuccess(file, response) {
      this.selectedOptions.fileName = response.file_name
    },
    validateForm() {
      let formAction = false
      let message = ''
      this.errors = []
      if (!this.selectedOptions.fileName) {
        this.errors.push('The File is required.')
      }

      if (this.errors.length > 0) {
        formAction = true
        // Send message to browser screen
        this.errors.forEach((element) => {
          message += '<li> ' + element + ' </li>'
        })
        this.$toastr.e("Error : <ul color='yellow'>" + message + '</ul>')
      }

      if (formAction === false) {
        this.saveData()
        // alert('se ejecuta saveData()')
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form action>
            <div class="card-body">
              <h4 class="header-title mb-3 mt-0"
                >Import Inland / Request: {{ request_id }} - <i> Inlands </i>
              </h4>
              <h4 v-if="messageBool" style="color:brown"> {{ message }}</h4>
              <div v-if="loadingData === false">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-4">
                      <label for="name"> Inland Reference </label>
                      <b-form-input
                        id="name"
                        v-model="reference"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-3">
                      <label for="name"> Validation </label>
                      <b-form-input
                        id="name"
                        v-model="validation"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Company </label>
                      <b-form-input
                        id="name"
                        v-model="company"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Provider </label>
                      <b-form-input
                        id="name"
                        v-model="provider"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-2">
                      <label for="name"> Country </label>
                      <b-form-input
                        id="name"
                        v-model="country"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Equipment </label>
                      <b-form-input
                        id="name"
                        v-model="equipment"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Direction </label>
                      <b-form-input
                        id="name"
                        v-model="direction"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Currency </label>
                      <b-form-input
                        id="name"
                        v-model="currency"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Type </label>
                      <b-form-input
                        id="name"
                        v-model="type"
                        value
                        placeholder="Not Assigned"
                        readonly
                      >
                      </b-form-input>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="form-group">
                  <div class="row">
                    <div class="col-xl-12 col-sm-12">
                      <div class="form-group mt-1 mt-sm-0">
                        <vue-dropzone
                          id="dropzone"
                          ref="myVueDropzone"
                          :options="selectedOptions.dropzoneOptions"
                          :destroyDropzone="false"
                          @vdropzone-removed-file="removeFile"
                          @vdropzone-success="vsuccess"
                        >
                          <div class="text-center">
                            <i class="h1 text-muted uil-cloud-upload"></i>
                            <h3>Drop files here or click to upload.</h3>
                            <span class="text-muted font-size-13">
                              (This is just a demo dropzone. Selected files are
                              <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                        </vue-dropzone>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-5 col-sm-5"></div>
                    <div class="col-xl-2 col-sm-2">
                      <div class="form-group mt-1 mt-sm-0">
                        <button
                          type="button"
                          name="save"
                          class="btn btn-primary form-control"
                          @click.prevent="validateForm"
                          >Save</button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="loadingData === true && waitingStatusC === true">
                <WaitingStatus
                  :request-id="request_id"
                  :reload-time="10"
                  @postevent="redirectAfterImport"
                  has-post-event
                  url="/inlands/getStatusTask/"
                />
              </div>
              <div
                v-else-if="loadingData === true && waitingStatusC === false"
                class="row align-items-center justify-content-center"
                style="height: 300px"
              >
                <div class="col-12 col-md-8 text-center">
                  <b-spinner
                    label="Loading..."
                    variant="primary"
                    class="ml-3"
                  ></b-spinner>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.vue-dropzone > .dz-preview .dz-remove {
  margin-left: 13px;
  padding: 33px;
  bottom: 55px;
}

.DRY {
  color: blue;
}
</style>
